import React from 'react';

export default function aboutPoly() {
    return (
        <div className="about-frame">
            <div id="about">
                <p>THIS PAGE IS UNDER DEVELOPMENT.</p>
            </div>
        </div>
    );
}